export type TabType = "labeling" | "navigation" | "action";

export interface KeyMapItem {
  id: string;
  action: string;
  desc: string;
  key: string;
  display?: string;
  modifier?: "Ctrl" | "Alt";
  default: string;
  defaultDisplay?: string;
}

export interface KeyConfig {
  labeling: KeyMapItem[];
  navigation: KeyMapItem[];
  action: KeyMapItem[];
}

export const DEFAULT_KEY_CONFIG: KeyConfig = {
  labeling: [
    { id: "l0", action: "라벨 1", desc: "첫 번째 클래스", key: "1", default: "1" },
    { id: "l1", action: "라벨 2", desc: "두 번째 클래스", key: "2", default: "2" },
    { id: "l2", action: "라벨 3", desc: "세 번째 클래스", key: "3", default: "3" },
    { id: "l3", action: "라벨 4", desc: "네 번째 클래스", key: "4", default: "4" },
    { id: "l4", action: "라벨 5", desc: "다섯 번째 클래스", key: "5", default: "5" },
    { id: "l5", action: "라벨 6", desc: "여섯 번째 클래스", key: "6", default: "6" },
    { id: "l6", action: "라벨 7", desc: "일곱 번째 클래스", key: "7", default: "7" },
    { id: "l7", action: "라벨 8", desc: "여덟 번째 클래스", key: "8", default: "8" },
    { id: "l8", action: "라벨 9", desc: "아홉 번째 클래스", key: "9", default: "9" },
    { id: "l9", action: "라벨 10", desc: "열 번째 클래스", key: "0", default: "0" },
  ],
  navigation: [
    {
      id: "n0",
      action: "이전 이미지",
      desc: "위쪽 화살표",
      key: "ArrowUp",
      display: "↑",
      default: "ArrowUp",
      defaultDisplay: "↑",
    },
    {
      id: "n1",
      action: "다음 이미지",
      desc: "아래쪽 화살표",
      key: "ArrowDown",
      display: "↓",
      default: "ArrowDown",
      defaultDisplay: "↓",
    },
  ],
  action: [
    {
      id: "a0",
      action: "라벨 초기화",
      desc: "현재 이미지 라벨 제거",
      key: "Backspace",
      display: "⌫",
      default: "Backspace",
      defaultDisplay: "⌫",
    },
    {
      id: "a1",
      action: "실행 취소",
      desc: "마지막 작업 되돌리기",
      key: "z",
      modifier: "Ctrl",
      display: "Ctrl+Z",
      default: "z",
      defaultDisplay: "Ctrl+Z",
    },
    {
      id: "a2",
      action: "저장",
      desc: "현재 상태 저장",
      key: "s",
      modifier: "Ctrl",
      display: "Ctrl+S",
      default: "s",
      defaultDisplay: "Ctrl+S",
    },
    {
      id: "a3",
      action: "전체 선택",
      desc: "모든 이미지 선택",
      key: "a",
      modifier: "Ctrl",
      display: "Ctrl+A",
      default: "a",
      defaultDisplay: "Ctrl+A",
    },
  ],
};
